export const CDN_URL = 'https://cdn.kursoved.pro/';

export const cdnFileUrl = (file: string) => `${CDN_URL}${file}`;

export const imgFileUrl = (file: string) => cdnFileUrl(`img/${file}`);
